import React from 'react';
import './SourcePill.scss';
import { ApsSource } from './types';

const LABELS: Record<ApsSource, string> = {
  Dx: 'DX',
  Rx: 'Rx',
  Disclosure: 'Disclosure',
  PreviouslyOrdered: 'Previously Ordered',
};

const CLASS_MODIFIERS: Record<ApsSource, string> = {
  Dx: 'dx',
  Rx: 'rx',
  Disclosure: 'disclosure',
  PreviouslyOrdered: 'prev',
};

interface SourcePillProps {
  source: ApsSource;
  prefix?: string;
}

const SourcePill = ({ source, prefix }: SourcePillProps) => (
  <span className={`source-pill ${CLASS_MODIFIERS[source]}`}>
    {prefix}
    {LABELS[source]}
  </span>
);

export default SourcePill;
